import { render } from "./EmailTemplateSelector.vue?vue&type=template&id=5ed40acd"
import script from "./EmailTemplateSelector.vue?vue&type=script&lang=js"
export * from "./EmailTemplateSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__